import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import Modals from "../../../components/modal";
import DeleteConfirmation from "../../../components/delete-confirmation";
import { useDeleteEvent } from "./hooks";
import { useUser } from "../../../common-hooks/user";

const DeleteEvent = ({ event }) => {
  const { handleDeleteEvent, isOpenModal, toggleModal, deleteEventLoading } =
    useDeleteEvent(event);

  const { isAdmin, isModerator } = useUser();

  if (!isAdmin && !isModerator) {
    return null;
  }

  return (
    <>
      <Tooltip title="Delete" placement="bottom">
        <i
          className={`fa fa-trash icon-btn-action text-danger `}
          onClick={toggleModal}
        ></i>
      </Tooltip>
      {isOpenModal ? (
        <Modals
          isOpenModal
          setIsOpenModal={toggleModal}
          message={
            <DeleteConfirmation
              message="Are you sure you want to delete?"
              handleDelete={handleDeleteEvent}
              isLoading={deleteEventLoading}
            />
          }
          title="Delete Event"
        />
      ) : null}
    </>
  );
};

export default DeleteEvent;
